import React, { useState } from 'react'
import { Box, Grid, Typography } from '@material-ui/core'
import { Header } from "@paro.io/base-ui";
import { IconCheck } from '@paro.io/base-icons';
import { LockOutlined } from '@material-ui/icons';
import Loader from '../../../_global/Loader';
import QuickBooksSteps from './QuickBookSteps';

export const steps = [
    {
        number: 1,
        title: "Create Account",
        completed: true
    },
    {
        number: 2,
        title: "Choose Your Import Method",
        completed: false
    },
    {
        number: 3,
        title: "Review & Import Clients",
        completed: false
    }
];

const ConnectQuickbooks = ({ history }) => {

    const [currentStep, setCurrentStep] = useState<number>(1); //default 1
    const [updatedSteps, setUpdateSteps] = useState<any[]>(steps);
    const [fetchingQuickbooks, setFetchingQuickbooks] = useState<boolean>(false);
    const [importedClients, setImportedClients] = useState<any[]>([]);
    const [allClients, setAllClients] = useState<any[]>([]);
    const [addClientsManually, setAddClientsManually] = useState(false);
    const [showExistingUsersWarning, setShowExistingUsersWarning] = useState(false);
    const [importedClientsCount, setImportedClientsCount] = useState<string | null>(null);
    const [addNewClientModal, setAddNewClientModal] = useState(false);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' },
                width: '100%',
                minHeight: '100vh',
                flexGrow: 1,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    bgcolor: '#060821',
                    padding: 25,
                    width: '100%',
                    maxWidth: { xs: '100%', md: '33%' },
                    color: '#fff',
                    boxSizing: 'border-box',
                    height: { xs: '100%', md: 'auto' },
                    flexGrow: 1,
                }}
            >
                <Header reverseColor={true} size="sm" className="sm-padding-rm" />
                <Typography variant="h5" style={{ fontWeight: 'bold', marginTop: 16, marginBottom: 16, color: '#fff' }}>
                    Get Started in 3 Simple Steps
                </Typography>
                <Box style={{ position: 'relative', marginBottom: '16px' }}>
                    {updatedSteps.map((step, index) => (
                        <Box key={step.number} style={{ position: 'relative' }}>
                            <Grid container alignItems="center" style={{ marginBottom: '16px' }}>
                                <Box
                                    style={{
                                        width: 48,
                                        height: 48,
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: `2px solid ${step.completed ? '#ffffff62' : '#248384'}`,
                                        backgroundColor: step.completed ? '#248384' : 'transparent',
                                        color: '#ffffff',
                                        position: 'relative',
                                        zIndex: 2,
                                    }}
                                >
                                    {step.completed ? (
                                        <IconCheck size="md" />
                                    ) : (
                                        <span
                                            style={{
                                                fontSize: '1.125rem',
                                                fontWeight: 600,
                                            }}
                                        >
                                            {step.number}
                                        </span>
                                    )}
                                </Box>
                                <Box
                                    style={{
                                        fontSize: '16px',
                                        fontWeight: 500,
                                        marginLeft: 24,
                                        color: '#ffffff',
                                    }}
                                >
                                    {step.title}
                                </Box>
                            </Grid>
                            {index < updatedSteps.length - 1 && (
                                <Box
                                    style={{
                                        position: 'absolute',
                                        left: 23,
                                        top: 48,
                                        width: 2,
                                        height: 16,
                                        backgroundColor: '#ffffff',
                                        zIndex: 1,
                                    }}
                                />
                            )}
                        </Box>
                    ))}
                </Box>
                <p
                    style={{
                        fontSize: '16px',
                        lineHeight: 1.6,
                        textAlign: 'center',
                        marginBottom: '32px',
                        color: 'rgba(255, 255, 255, 0.8)',
                    }}
                >
                    {currentStep < 2
                        ?
                        `Save time by connecting directly to QuickBooks or uploading a CSV. We'll automatically import your client list with their company and financial information to help you get started quickly.`
                        :
                        'Once you import your clients, you’ll be ready to automate tasks, assign work, and manage billing and relationships right away—no spreadsheets or double entry required.'
                    }
                </p>
                <Box
                    style={{
                        backgroundColor: '#ffffff',
                        borderRadius: 16,
                        padding: 16,
                        boxShadow:
                            '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                    }}
                >
                    <Grid container direction="row" alignItems="center" spacing={1}>
                        <Grid item>
                            <LockOutlined fontSize="medium" color="primary" />
                        </Grid>
                        <Grid item xs>
                            <p
                                style={{
                                    fontSize: '0.875rem',
                                    lineHeight: 1.5,
                                    color: '#334155',
                                    margin: 0,
                                }}
                            >
                                We use official, encrypted APIs to connect with QuickBooks—Paro never sees your login
                                credentials.
                            </p>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            {fetchingQuickbooks
                ?
                <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
                    <Loader />
                </Grid>
                :
                <QuickBooksSteps
                    currentStep={currentStep}
                    setFetchingQuickbooks={setFetchingQuickbooks}
                    updatedSteps={updatedSteps}
                    setUpdateSteps={setUpdateSteps}
                    setCurrentStep={setCurrentStep}
                    importedClients={importedClients}
                    setImportedClients={setImportedClients}
                    history={history}
                    allClients={allClients}
                    setAllClients={setAllClients}
                    addClientsManually={addClientsManually}
                    setAddClientsManually={setAddClientsManually}
                    showExistingUsersWarning={showExistingUsersWarning}
                    setShowExistingUsersWarning={setShowExistingUsersWarning}
                    importedClientsCount={importedClientsCount}
                    setImportedClientsCount={setImportedClientsCount}
                    addNewClientModal={addNewClientModal}
                    setAddNewClientModal={setAddNewClientModal}
                />
            }
        </Box>
    )
}

export default ConnectQuickbooks;